import PropTypes from "prop-types";
import { intlMessageShape } from "./intlMessageShape";
export var avatarPropTypes = {
  username: PropTypes.string,
  title: intlMessageShape,
  subtitle: intlMessageShape,
  imageSource: PropTypes.string
};
export var avatarShape = PropTypes.shape(avatarPropTypes);